import {Component, OnDestroy, OnInit} from '@angular/core';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {RegionModel} from '../../../../models/RegionModel';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {DiscountService} from '../service-discount/discount.service';
import * as toastr from 'toastr';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {DiscountModel} from '../../../../models/DiscountModel';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import {ProviderModel} from '../../../../models/ProviderModel';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';

@Component({
  selector: 'app-edit-discount',
  templateUrl: './edit-discount.component.html',
  styleUrls: ['./edit-discount.component.scss']
})
export class EditDiscountComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  showActions: boolean;
  anagrafInSettings: boolean;
  showAnno: boolean;

  discount: DiscountModel;
  localCustomerSelect: LocalCustomerModel;
  regionSelect: RegionModel;
  providerSelect: ProviderModel;
  discountSelect: number;
  numAnnoSelect: number;
  selected: string;
  saveDiscount: Subscription;
  parameterSubscribe: Subscription;

  registerForm: FormGroup;
  submitted = false;
  discountJson: any;

  allYear: any;
  getPageSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private discountService: DiscountService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService) {
    super();

    this.showActions = false;
    this.anagrafInSettings = true;
    this.showAnno = false;
    this.discount = new DiscountModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();
    this.providerSelect = new ProviderModel();
  }

  ngOnInit() {
    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.discountJson = params['row'];
        this.discount = JSON.parse(this.discountJson) as DiscountModel;
        this.localCustomerSelect = this.discount.localCustomer;
        this.regionSelect = this.discount.region;
        this.providerSelect = this.discount.provider;
        this.discountSelect = this.discount.discount;
        this.numAnnoSelect = this.discount.numAnno;

      });

    this.getAllYear();

    this.registerForm = this.formBuilder.group({
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      region: [{value: '', disabled: false}, Validators.required],
      provider: [{value: '', disabled: false}, Validators.required],
      discount: [{value: '', disabled: false}, Validators.required],
      anno: [{value: '', disabled: false}, Validators.required]
    });

    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });

    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });

    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });

    this.registerForm.patchValue({
      discount: this.discountSelect
    });

    this.registerForm.patchValue({
      anno: this.numAnnoSelect
    });
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 1}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.loaderService.display(true);
          this.discount.discount = this.registerForm.value.discount;
      this.saveDiscount = this.discountService.update(this.discountService.baseUrl, this.discount)
        .subscribe(
          (result: any) => {
            toastr.success('Discount element was edited with success', 'Success');
            this.loaderService.display(false);
            this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 1}});
          },
          error => {
            toastr.error('Discount element was not edited', 'Error');
            this.loaderService.display(false);
          });
    }
  }

  ngOnDestroy(): void {
    if (this.saveDiscount) {
      this.saveDiscount.unsubscribe();
    }
    if (this.parameterSubscribe) {
      this.parameterSubscribe.unsubscribe();
    }
  }

  getElementSelectedLC($event) {
    this.discount.localCustomer = $event.row;
    this.localCustomerSelect = $event.row;
    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });
  }

  getElementSelectedRegion($event) {
    this.discount.region = $event.row;
    this.regionSelect = $event.row;
    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });
  }

  getElementSelectedProvider($event) {
    this.discount.provider = $event.row;
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });
  }

  handle(value) {
    this.discount.numAnno = value;
    this.registerForm.patchValue({
      anno: value
    });
  }
  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  getAllYear() {
    this.getPageSubscribe = this.annoMeseService.getAllYear()
      .subscribe(
        (result: any) => {
          this.allYear = result;
        });
  }
}


